import { Dialog } from "@verde/compose-ui";
import {
  CheckIcon,
  ChevronLeftIcon,
  CircleStackIcon,
  XIcon,
} from "@verde/icons";
import { IconButton } from "@verde/ui-core";
import React, { createElement, useEffect } from "react";
import { create } from "zustand";
import CreditDialogExpired from "./credit-dialog-expired";
import CreditDialogPayment from "./credit-dialog-payment";
import CreditDialogSelect from "./credit-dialog-select";
import CreditDialogSuccess from "./credit-dialog-success";
import type { CreditDialogProps, UseCreditDialog } from "./types";

export const DIALOG_KIND = {
  payment: {
    kind: null,
    icon: null,
    title: "Comprar créditos: Pagamento",
    component: CreditDialogPayment,
  },
  success: {
    kind: "success",
    icon: <CheckIcon />,
    title: "Comprado com sucesso!",
    component: CreditDialogSuccess,
  },
  expired: {
    kind: "error",
    icon: <XIcon className="text-feedback-error" />,
    title: "O pagamento não foi registrado",
    component: CreditDialogExpired,
  },
  default: {
    kind: null,
    icon: null,
    title: "Comprar créditos: Raio-X rural",
    component: CreditDialogSelect,
  },
} as const;

export const useCreditDialog = create<UseCreditDialog>((set) => {
  return {
    kind: "default",
    selectedCredit: undefined,
    selectedInvoice: undefined,
    onClose: () => undefined,
    setKind: (kind) => {
      set(() => ({ kind }));
    },
    setSelectedCredit: (selectedCredit) => {
      set(() => ({ selectedCredit }));
    },
    setSelectedInvoice: (selectedInvoice) => {
      set(() => ({ selectedInvoice }));
    },
  };
});

function CreditDialog({ defaultKind = "default", onClose }: CreditDialogProps) {
  const { kind, setKind } = useCreditDialog();

  useEffect(() => {
    useCreditDialog.setState(() => {
      return {
        kind: defaultKind,
        onClose,
      };
    });
  }, [defaultKind, onClose]);

  return (
    <Dialog
      open
      size="sm"
      onClose={kind === "payment" ? undefined : onClose}
      header={{
        size: "lg",
        title: DIALOG_KIND[kind].title,
        icon:
          kind === "payment" ? (
            <IconButton onClick={() => setKind("default")}>
              <ChevronLeftIcon />
            </IconButton>
          ) : (
            DIALOG_KIND[kind]?.icon || <CircleStackIcon />
          ),
        kind: DIALOG_KIND[kind]?.kind || "warning",
      }}
    >
      {createElement(DIALOG_KIND[kind].component)}
    </Dialog>
  );
}

export default React.memo(CreditDialog);
